import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "../helper/helper.service";
var ApiService = /** @class */ (function () {
    function ApiService(http, helper) {
        this.http = http;
        this.helper = helper;
        this.apiUrl = environment.apiUrl;
    }
    ApiService.prototype.getOutTxHistory = function (address, slice) {
        // return this.http.get(this.apiUrl + '/addresses/'+'0xe88bf2e91f8003c0bfcb88290e821d399141b5a8'+ '/outtxs/' + slice);
        return this.http.get(this.apiUrl + '/addresses/' + this.helper.accountList[this.helper.slectedAddress] + '/outtxs/' + slice);
    };
    ApiService.prototype.getInTxHistory = function (address, slice) {
        // return this.http.get(this.apiUrl + '/addresses/'+'0xe88bf2e91f8003c0bfcb88290e821d399141b5a8'+ '/intxs/' + slice);
        return this.http.get(this.apiUrl + '/addresses/' + this.helper.accountList[this.helper.slectedAddress] + '/intxs/' + slice);
    };
    ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.Http), i0.ɵɵinject(i2.HelperService)); }, token: ApiService, providedIn: "root" });
    return ApiService;
}());
export { ApiService };
